import redirectTo from '../../redirectTo';

export default clientId => redirectTo(`/create-new-visit/guest/${clientId}`);
